import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    i18next: {
        ns: 'md-snapshot-search'
    },
    computed: {
        needMore() {
            //  Whether to display the anchor point to md-form module button 
            const modules = this.$root.moduleData;
            for (let mdModule of modules) {
                if (mdModule.name === 'md-form') {
                    return true;
                }
            }
            return false;
        },
        ...rootMapState(usePageStore, {
            "page": store => store.page || {}
        }),
        noDataText({ page, $t }) {
            if (page.pageKey === 'featured-area-market') {
                return $t('md-snapshot-search.featureAreaNoDataDesc')
            }
            return $t('md-snapshot-search.thereAreNoSoldListings')
        }
    },
    methods: {
        scrollToForm() {
            const ele = document.querySelectorAll('.md-form')[0];
            if (ele) {
                ele.scrollIntoView();
            }
        }
    }
};
